import { ListingItemInterface } from "../../interfaces/listing-item.interface";
import { ListingItemMutatorInterface } from "../../interfaces/listing-item-mutator.interface";
import { GraphService } from "../../../graphql/services/graph.service";
import { BaseListing } from "../classes/base-listing";

export abstract class ListItemRefModel implements ListingItemInterface {
  protected _action: { name: string; data?: any } | undefined;
  mutator!: ListingItemMutatorInterface;

  protected constructor(
    protected data: any,
    protected index: number,
    protected parent: BaseListing,
    private graphService: GraphService
  ) {}

  /** access to the index of the row */
  get rowIndex(): number {
    return this.index;
  }

  /**
   * Returns the parent listing item <TableComponent>
   */
  getParent(): BaseListing {
    return this.parent;
  }

  /**
   * Returns the row data object.
   */
  abstract getData(): any;

  /**
   * Returns specific information from the row data object.
   * @param key
   */
  abstract get(key: string): any;

  /**
   * Sets specific information to the row data object.
   * @param key
   * @param value
   */
  abstract set(key: string, value: any): ListingItemInterface;

  /**
   * Removes this row.
   */
  remove(commit = true) {
    this.addClass("to-remove");
    this._action = { name: "remove" };
    if (commit) {
      this.commit();
    }
  }

  /**
   * adds a class to the row.
   * @param _class
   * @param commit
   */
  abstract addClass(_class: string, commit?: boolean | undefined): void;

  /**
   * removes a class from the row.
   * @param _class
   * @param commit
   */
  abstract removeClass(_class: string, commit?: boolean | undefined): void;

  /**
   * Commits the last registered action.
   */
  abstract commit(): void;

  /**
   * Reverts the last registered action.
   */
  revert() {
    this.parent.removeItemClass(this.index, "item-loading");
    switch (this._action?.name) {
      case "remove":
        this.parent.removeItemClass(this.index, "to-remove");
        break;
      default:
        break;
    }
    this._action = undefined;
  }
}
